/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Date_LabelInputs */

const fr_vehicle_action_archive_date_label = /** @type {(inputs: Vehicle_Action_Archive_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date d'archivage`)
};

const en_vehicle_action_archive_date_label = /** @type {(inputs: Vehicle_Action_Archive_Date_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archive date`)
};

/**
* | output |
* | --- |
* | "Archive date" |
*
* @param {Vehicle_Action_Archive_Date_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_date_label = /** @type {((inputs?: Vehicle_Action_Archive_Date_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Date_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_date_label(inputs)
	return en_vehicle_action_archive_date_label(inputs)
});